import { configureStore } from "@reduxjs/toolkit";
import { adminAuthApi } from "./api/adminAuthApi";
import { adminApi } from "./api/adminApi";
import authReducer from "./authSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [adminAuthApi.reducerPath]: adminAuthApi.reducer,
    [adminApi.reducerPath]: adminApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(adminAuthApi.middleware)
      .concat(adminApi.middleware),
});
